import React from 'react';

import CardList from 'Site/Ui/CardList';
import TagFilter from 'Core/Components/TagFilter';

class FilteredCardList extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      filteredList: props.list
    };

    this.updateFilteredList = this.updateFilteredList.bind(this);
  }

  updateFilteredList (filteredList) {
    this.setState({ filteredList });
  }

  render () {
    const { filteredList } = this.state;
    const { multiFilter, list, filters, showAllOption } = this.props;

    return (
      <div className="FilteredCardList">
        <TagFilter
          single={!multiFilter}
          onFilter={this.updateFilteredList}
          list={list}
          filters={filters}
          allOption={showAllOption || 'Show All'}
        />
        <CardList list={filteredList} />
      </div>
    );
  }
};

export default FilteredCardList;



// WEBPACK FOOTER //
// ./client/Site/Ui/FilteredCardList.jsx